import Axios from '../packages/axios/Axios';

export default {
  methods: {
    metricsEnabled() {
      return window.localStorage.getItem('disable-metrics') !== 'true';
    },
    writeMetric(type, data = {}) {
      if(this.metricsEnabled()) {
        Axios.post('/v1/metrics', {
          type,
          data: JSON.stringify(data),
        });
      }
    },
  },
};
